"use client"

import styled from "styled-components"

const segments = [
  { label: "US Equity", value: 58, color: "var(--color-optimal)" },
  { label: "Intl Equity", value: 24, color: "var(--color-caution)" },
  { label: "Bonds", value: 18, color: "var(--color-alert)" },
]

const Card = styled.section`
  border-radius: 1.5rem;
  background: var(--color-card);
  padding: 1.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border: 1px solid color-mix(in oklch, var(--color-border) 60%, transparent);
`

const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--color-card-foreground);
  margin: 0;
`

const Legend = styled.div`
  margin-top: 1.25rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
`

const LegendItem = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.375rem;
`

const Value = styled.span`
  font-family: var(--font-mono);
  font-size: 1.125rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--color-card-foreground);
`

const Label = styled.span`
  font-size: 0.875rem;
  color: var(--color-muted-foreground);
`

const Bar = styled.div`
  margin-top: 1rem;
  display: flex;
  height: 0.5rem;
  width: 100%;
  gap: 0.25rem;
  overflow: hidden;
`

const BarSegment = styled.div<{ $width: number; $color: string }>`
  height: 100%;
  border-radius: 9999px;
  width: ${(p) => p.$width}%;
  background: ${(p) => p.$color};
`

export default function AllocationCard() {
  return (
    <Card>
      <Title>14 Funds tracked</Title>

      <Legend>
        {segments.map((s) => (
          <LegendItem key={s.label}>
            <Value>{s.value}%</Value>
            <Label>{s.label}</Label>
          </LegendItem>
        ))}
      </Legend>

      <Bar>
        {segments.map((s) => (
          <BarSegment
            key={s.label}
            $width={s.value}
            $color={s.color}
            role="presentation"
          />
        ))}
      </Bar>
    </Card>
  )
}
